import { createContext } from 'react';

const BatchFormContext = createContext({
  action: null,
  batch: null,
  dataset: null,
});

export default BatchFormContext;
